import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './Header.css';
import IconList from './IconList/IconList';
import { getStepTitle } from '../../../utils';
import { withRouter } from 'react-router-dom';
import { ROUTES_NO_HEADER, ROUTES, EDIT_BOOKING_STEPS } from '../../../constants';

class Header extends Component {
  render() {
    const currentPath = this.props.history.location.pathname;
    const shouldShowHeader = ROUTES_NO_HEADER.indexOf(currentPath) === -1;

    let title = null;
    if (!shouldShowHeader) {
      let titleText = '';
      if (this.props.editBookingCurrentStep === EDIT_BOOKING_STEPS.SEARCH_BOOKING ) {
        titleText = this.props.translations.label_search_title_header;
      } else {
        titleText = this.props.translations.label_search_booking_details;
      }

      title = <span className={[classes.HeaderTitle, classes.HeaderTitleNoSteps].join(' ')}>
        {titleText}
      </span>
    } else {
      const restaurantName = this.props.restaurantName !== null && this.props.step > 0 ?
        <span className={classes.RestaurantName}> /{this.props.restaurantName}</span> : null;

      title = <React.Fragment><span className={classes.HeaderTitle}>
        {this.props.translations.label_book_table}
      </span>{restaurantName}</React.Fragment>
    }
    return (
      <div className={classes.Header} style={!shouldShowHeader ? { justifyContent: 'center' } : {}}>
        <div className={classes.HeaderTexts}>
          {title}
        </div>
        {
          shouldShowHeader &&
          <React.Fragment>
            <p className={classes.PageTitle}>{getStepTitle(
              this.props.step,
              this.props.translations,
              this.props.hasSelectedCountry,
              this.props.isRoom
            )}</p>
            <div className={classes.Steps}>
              <IconList
                activeIcon={this.props.step}
                translations={this.props.translations}
              />
            </div>
          </React.Fragment>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  const selectedStore = state.storeReducer.stores[state.storeReducer.storeIdSelected];
  const availablePromotions = state.bookingProcessReducer.availablePromotions;

  let storeName = '';
  if (selectedStore) {
    storeName = selectedStore.storeName;
  }

  let isRoom = true;
  if (availablePromotions) {
    for (let promotion of availablePromotions) {
      if (promotion.promotionPrice !== 0) {
        isRoom = false;
        break;
      }
    }
  }

  return {
    restaurantName: storeName,
    step: state.bookingProcessReducer.currentStep,
    translations: state.settingsReducer.translations || {},
    hasSelectedCountry: state.storesReducer.selectedCountry,
    isRoom,
    editBookingCurrentStep: state.editBookingState.editBookingCurrentStep
  };
};

export default withRouter(connect(mapStateToProps, null)(Header));



// WEBPACK FOOTER //
// ./src/components/UI/Header/Header.js